import { render, staticRenderFns } from "./veJkyProjectShow.vue?vue&type=template&id=61a7c9a5&scoped=true"
import script from "./veJkyProjectShow.vue?vue&type=script&lang=js"
export * from "./veJkyProjectShow.vue?vue&type=script&lang=js"
import style0 from "./veJkyProjectShow.vue?vue&type=style&index=0&id=61a7c9a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a7c9a5",
  null
  
)

export default component.exports